<template>
    <div>
        <el-form ref="formRef" :model="form" label-width="150px" :rules="rules">
            <el-form-item label="名称" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="投资情况" prop="investment">
                <span>(数据顺序:累计服务企业数|累计授信金额|黑计贷款金额)</span>
                <el-input type="textarea" :rows="2" placeholder="74家|99999万元|99999万元" v-model="form.investment">
                </el-input>
            </el-form-item>
            <el-form-item label="服务数据" prop="serviceData">
                <span>(标签以竖线相隔)</span>
                <el-input type="textarea" :rows="2" placeholder="金融机构22家(及101家地方农商行)|保险机构4家|投资机构16家" v-model="form.serviceData">
                </el-input>
            </el-form-item>
            <el-form-item label="投资领域" prop="investmentAreas">
                <span>(数据顺序:交通与运输|生物与医药|农业与化工|能源与采矿|自然与社科)</span>
                <el-input type="textarea" :rows="2" placeholder="1|2|3|4|5" v-model="form.investmentAreas">
                </el-input>
            </el-form-item>
            <el-form-item label="投资企业分布" prop="investmentEnterpriseDistribution">
                <span>(地区顺序:酒泉|嘉峪关|张掖|金昌|武威|白银|兰州|临豆|定西|天水|陇南|平凉|庆阳|甘南)</span>
                <el-input type="textarea" :rows="2" placeholder="1|2|3|4|5" v-model="form.investmentEnterpriseDistribution">
                </el-input>
            </el-form-item>
            <el-form-item style="display: flex;justify-content: center;margin-left: -150px;">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button @click="resetForm">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                title: '',
                investment: '',
                serviceData: '',
                investmentAreas: '',
                investmentEnterpriseDistribution:'',
                id: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                investment: [
                    { required: true, message: '请输入投资情况', trigger: 'blur' }
                ],
                serviceData: [
                    { required: true, message: '请输入服务数据', trigger: 'blur' }
                ],
                investmentAreas: [
                    { required: true, message: '请输入投资领域', trigger: 'blur' }
                ],
                investmentEnterpriseDistribution: [
                    { required: true, message: '请输入投资企业分布', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        onSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.form,
                    }
                    this.http.put('apij2/admin-api/voucher/large-screen-technology-finance-management/update', params).then((res) => {
                        if (res.data) {
                            this.resetForm()
                            this.$message({
                                message: '编辑成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                message: '请检查表单内容',
                                type: 'warning'
                            });
                        }

                    });
                } else {
                    this.$message({
                        message: '请检查表单内容',
                        type: 'warning'
                    });
                }
            })

        },
        onClose() {
            this.$emit('onClose')
        },
        resetForm() {
            this.$emit('onSubmit')
            this.$refs.formRef.resetFields();
        },
        getData(row) {
            this.form = { ...row }
        }
    }
}   
</script>
<style scoped lang="scss">
span {
    color: #868686;
    font-size: 12px;
}
</style>